import React, { useContext, useEffect, useState, useRef } from "react";
import styles from "./UserDropdown.module.scss";
import {
  ArrowDropDownRounded,
  PersonRounded,
  ListRounded,
  ExitToAppRounded,
  GitHub,
  SettingsRounded,
} from "@material-ui/icons";
import AppContext from "context/AppContext";

import { Link, useHistory } from "react-router-dom";
import cn from "classnames";
import { Paths } from "shared/types/navigation";

import useOutsideClick from "shared/utils/useOutsideClick";

import CircularProgress from "@material-ui/core/CircularProgress";

import useLogin from "shared/utils/useLogin";

const UserDropdown = () => {
  const [open, setOpen] = useState(false);
  const { state, dispatch } = useContext(AppContext);
  const history = useHistory();

  const dropDownRef = useRef<HTMLDivElement>(null);

  useOutsideClick(dropDownRef, () => setOpen(false));

  const dropdownItems = [
    {
      to: `/profile/${state.user?.id}`,
      label: "My profile",
      Icon: PersonRounded,
    },

    {
      to: Paths.mySolutions,
      label: "My challenges",
      Icon: ListRounded,
    },

    {
      to: Paths.settings,
      label: "Settings",
      Icon: SettingsRounded,
    },
  ];

  const {
    getUser,
    loginWithGithub,
    signOut,
    getUserSolutions,
    getUserBadges,
  } = useLogin({
    dispatch,
  });

  useEffect(() => {
    if (!state.user?.uid) {
      getUser();
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchUserSolutions = async () => {
      if (!state.userSolutions && state.user?.uid) {
        await getUserSolutions(state.user?.uid);
        await getUserBadges(state.user?.uid);
      }
    };

    fetchUserSolutions();

    // eslint-disable-next-line
  }, [state.user?.uid]);

  if (state.loadingUser) {
    return (
      <div className={styles.userDropdown_userLoader}>
        <CircularProgress size="1rem" thickness={6} />
      </div>
    );
  }

  if (!state.user) {
    return (
      <button
        aria-label="login with github"
        className={styles.userDropdown_loginButton}
        onClick={loginWithGithub}
      >
        <span>Login with Github</span> <GitHub fontSize="inherit" />
      </button>
    );
  }

  return (
    <div className={styles.userDropdown} ref={dropDownRef}>
      {open && (
        <div
          className={styles.userDropdown_dropdown}
          onClick={() => setOpen(false)}
        >
          <ul className={styles.userDropdown_dropdown_list}>
            {dropdownItems.map(({ to, label, Icon }) => (
              <li
                key={to}
                className={cn([styles.userDropdown_dropdown_list_item])}
              >
                <Link
                  to={to}
                  className={styles.userDropdown_dropdown_list_button}
                >
                  <Icon fontSize="small" />

                  <span
                    className={styles.userDropdown_dropdown_list_item_label}
                  >
                    {label}
                  </span>
                </Link>
              </li>
            ))}

            <div
              style={{
                height: "1px",
                width: "100%",
                margin: "var(--space-xs) 0",
                backgroundColor: "var(--grey-3)",
              }}
            />

            <li className={cn([styles.userDropdown_dropdown_list_item])}>
              <button
                aria-label="sign out"
                className={styles.userDropdown_dropdown_list_button}
                onClick={() => {
                  history.push(Paths.challenges);
                  signOut();
                }}
              >
                <ExitToAppRounded fontSize="small" />

                <span className={styles.userDropdown_dropdown_list_item_label}>
                  Sign out
                </span>
              </button>
            </li>
          </ul>
        </div>
      )}

      <button
        className={styles.userDropdown_button}
        onClick={() => setOpen(!open)}
        aria-label="user"
      >
        <div className={styles.userDropdown_user}>
          <img loading="lazy" src={state.user.picture} alt={state.user.name} />
        </div>
        <ArrowDropDownRounded />
      </button>
    </div>
  );
};

export default UserDropdown;
